import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledPlatofrmsHero = styled.section`
	text-align: center;
	overflow: hidden;
	background: url(/assets/hero-bg.webp);
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center 0%;
	color: ${CSSVars.white};

	.hero-wrapper {
		padding: 80px 20px 50px;

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			padding: 130px 40px 100px;
		}
		position: relative;

		h1 {
			position: relative;
			z-index: 10;
			margin: 0 auto;
			font-size: ${CSSVars.fontSize2XL};
			max-width: 600px;
			margin-bottom: 20px;
			text-align: left;

			@media screen and (min-width: ${CSSVars.breakpointSM}) {
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				max-width: 750px;
				font-size: ${CSSVars.fontSize3XL};
			}
		}

		h2 {
			position: relative;
			z-index: 10;
			margin: 0 auto;
			font-size: ${CSSVars.fontSizeLG};
			max-width: 600px;
			font-weight: 300;
			text-align: left;

			@media screen and (min-width: ${CSSVars.breakpointSM}) {
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				max-width: 670px;
				font-size: ${CSSVars.fontSizeXL};
			}
		}
	}
`;
